var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 52.24 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0.75 0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-1.43 48.43 59.91 48.43 59.91 -2.43 -1.43 -2.43 -1.43 48.43 -1.43 48.43",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.73,
    y: 1.13,
    width: 43.38,
    height: 43.75,
    rx: 7.23,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 8,
    strokeWidth: 2.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "14.68 10.85 35.52 23 14.68 35.16 14.68 28.16 0.75 28.16 0.75 17.84 14.68 17.84 14.68 10.85 14.68 10.85",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.68 10.85 35.52 23 14.68 35.16 14.68 28.16 0.75 28.16 0.75 17.84 14.68 17.84 14.68 10.85 14.68 10.85",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 8,
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.f46c06aa8135d447542a923d4c629458.svg";
export { ForwardRef as ReactComponent };